<template>
  <div>
    <div class="main-container">
     <!-- <breadcrumb :list="breadcrumbList" /> -->
      <br />

      <tl-tabs :tabs="tabs" :customclass="true" class="margintop-20" @changeTab="onTabChange()">
        <tl-tab>
          <add-exit-employees />
        </tl-tab>
        <tl-tab>
          <exiting-employees-list :empList="employeeData" />
        </tl-tab>
      </tl-tabs>
    </div>
  </div>
</template>
<script>
import addExitEmployees from "./addExitEmployees.vue";
import exitingEmployeesList from "./exitingEmployeesList.vue";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  components: {
    addExitEmployees,
    exitingEmployeesList
  },
  data() {
    return {
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Add Exit Employee/s",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/add_exit_employees`
        }
      ],
      employeeData: [],
      tabs: [
        {
          header: "Add Exit Employees"
        },
        {
          header: "Exiting Employees List"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {
    ...mapActions({
      act_fetchAll: "dashboard/payroll/utilities/addexitemployees/fetchExits"
    }),
    routeToMainStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll`
      });
    },
    routeToSubStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      });
    },
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);

        if (res.data.status) {
          this.employeeData = res.data.payload;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    onTabChange() {
      this.fetchAll();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
